var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/services"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.696 5.844v.053m0 0v12.042a4.319 4.319 0 0 1-4.319 4.318H6.622a4.319 4.319 0 0 1-4.318-4.319V5.898m19.392 0a1.144 1.144 0 0 0-.234-.941L19.694 2.39c-.33-.41-.82-.648-1.336-.648H5.642c-.517 0-1.006.237-1.336.648L2.538 4.956c-.23.286-.294.628-.234.941m19.392 0c-.096.5-.51.923-1.084.923h-2.254M2.304 5.897c.096.5.51.923 1.084.923h2.254m12.716 0H5.642m12.716 0V2.317M5.642 6.82V2.391M9.916 13.49l-2.875-.615 1.878 5.132 7.826-1.455.013-5.616-2.568 1.679-2.53-2.2-1.744 3.075Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.a8dc8ec28ca1974267b915e040acb8eb.svg";
export { ForwardRef as ReactComponent };